import React, {useState} from 'react';
import logo from '../../assets/images/logo.png';
import logo_icon_only from '../../assets/images/logo_icon_only.png';
import twitter from '../../assets/images/twitter.svg';
import discord from '../../assets/images/discord.svg';
import medium from '../../assets/images/medium.svg';
import wallet from '../../assets/images/wallet.svg';
import logout from '../../assets/images/logout.svg';

const Header = ({staked}) => {
    const [isWalletConnected, setIsWalletConnected] = useState(false);
    const [walletAddress, setWalletAddress] = useState("");
    const [logoutHover, setLogoutHover] = useState(false);

    const truncate = (str, length) => {
        return str.length > length
            ? `${str.substring(0, length)}...`
            : str;
    }

    return (
        <header className="flex justify-between place-items-center mb-[50px] px-5 lg:px-20 py-8">
            <img className="hidden lg:block" src={logo} width={280} alt="logo"></img>
            <img className="block lg:hidden" src={logo_icon_only} width={45} alt="logo"></img>
            <div className="flex gap-3 lg:gap-5">
                <a className="hvr-grow" href="#" target="_blank">
                    <div
                        className="flex w-[37px] h-[37px] bg-[rgba(255,_255,_255,_0.15)] rounded-full place-items-center justify-center">
                        <img src={twitter} width={20} alt={"twitter"}/>
                    </div>
                </a>
                <a className="hvr-grow" href="#" target="_blank">
                    <div
                        className="flex w-[37px] h-[37px] bg-[rgba(255,_255,_255,_0.15)] rounded-full place-items-center justify-center">
                        <img src={discord} width={20} alt={"twitter"}/>
                    </div>
                </a>
                <a className="hvr-grow" href="#" target="_blank">
                    <div
                        className="flex w-[37px] h-[37px] bg-[rgba(255,_255,_255,_0.15)] rounded-full place-items-center justify-center">
                        <img src={medium} width={20} alt={"twitter"}/>
                    </div>
                </a>
                {
                    staked &&
                    <>
                        <div className="flex cursor-pointer">
                            <div
                                className="flex bg-[rgba(255,_255,_255,_0.15)] relative rounded-[15px] gap-2"
                                onClick={() => {
                                    !isWalletConnected &&
                                    setIsWalletConnected(true)
                                    setWalletAddress("8a2FzYKAokQmeWiTMr1xSy6eXzuTCRaqzgDFt3HEHoSv")
                                }}>
                                <img className="self-center hidden lg:block ml-[10px]" src={wallet} width={20} alt="wallet"/>
                                <p className={`self-center ${isWalletConnected ? "mr-14" : "mr-4"} flex ml-4 lg:ml-0 font-gilroy font-medium normal-case text-[16px]`}>
                                    {isWalletConnected ? truncate(walletAddress, window.innerWidth >= 1024 ? 15 : 5) : "Connect wallet"}
                                </p>
                                {
                                    isWalletConnected &&
                                    <div
                                        className="flex h-[37px] bg-[#D75857] rounded-[15px] place-items-center justify-center px-3 py-2 absolute right-0"
                                        onClick={() => {
                                            setIsWalletConnected(false)
                                        }}
                                        onMouseEnter={() => {
                                            setLogoutHover(true)
                                        }}
                                        onMouseLeave={() => {
                                            setLogoutHover(false)
                                        }}>
                                        <img src={logout} alt="logout" width={20}/>
                                        <p className={`ml-2 ${!logoutHover && "hidden"} font-gilroy font-medium normal-case`}>Logout</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </>
                }
            </div>
        </header>
    );
};

export default Header;